import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Document,
  Page,
  Text,
  View,
  PDFViewer,
  StyleSheet,
  Image,
  pdf,
} from "@react-pdf/renderer";
import axios from "axios";
import config from "../../config";

const styles = StyleSheet.create({
  page: { padding: 15, fontSize: 10, fontFamily: "Helvetica" },
  headerContainer: { textAlign: "center", marginBottom: 5 },
  title: { fontSize: 12, fontWeight: "bold", marginBottom: 2 },
  separator: { borderBottom: "1 solid black", marginVertical: 5 },
  section: { marginBottom: 4 },
  label: { fontWeight: "bold" },
  note: {
    marginTop: 10,
    fontSize: 8,
    borderTop: "1 solid black",
    paddingTop: 5,
    textAlign: "center",
  },
});

const formatChallanDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;
};

const ChallanPDF = ({ challanData, categoryList }) => (
  // const ChallanPDF = ({ challanData, }) => (
  <Document>
    {["JAC COPY", "SCHOOL COPY", "BANK COPY"].map((copyType, index) => (
      <Page key={index} size="A4" style={styles.page}>
        <View style={{ position: "absolute", top: 10, right: 15 }}>
          <Text>({copyType})</Text>
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: -5,
            marginBottom: 10,
          }}
        >
          {/* Logo Section */}
          {/* <Image
            src="../assets/images/jac-academic-council.png"
            style={{
              width: 50,
              height: 50,
              marginRight: 10,
            }}
          /> */}

          {/* Header Text Section */}
          <View style={{ flex: 1, textAlign: "center", marginLeft: -60 }}>
            <Text style={{ fontSize: 12, fontWeight: "bold" }}>
              Jharkhand Academic Council, Ranchi
            </Text>
            <Text style={{ marginTop: 4, fontSize: 10 }}>
              RTGS / NEFT Remittance Advice for{" "}
              <Text style={{ fontWeight: "bold" }}>
                Class XI Registration - 2026 (Annual)
              </Text>
            </Text>
            <Text style={{ marginTop: 4, fontSize: 9 }}>
              (To be submitted in original along with the consolidated
              statement)
            </Text>
          </View>
        </View>

        <View style={styles.separator} />

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: "-5px",
          }}
        >
          <Text style={styles.section}>
            <Text style={styles.label}>Challan No: </Text>{" "}
            {challanData?.challaN_NO || "N/A"}
          </Text>
          <Text style={styles.section}>
            <Text style={styles.label}>Challan Generated On: </Text>{" "}
            {formatChallanDate(challanData?.challaN_DATE_TIME)}
          </Text>
        </View>
        <View style={styles.separator} />
        <View>
          <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 5 }}>
            1. BENEFICIARY DETAILS:
          </Text>

          {/* A/C Name */}
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 120 }}>a. A/C Name</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>
              {challanData?.aC_NAME || "N/A"}
            </Text>
          </View>

          {/* Bank Name */}
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 120 }}>b. Bank Name</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>
              {challanData?.banK_NAME || "N/A"}
            </Text>
          </View>

          {/* Branch Name */}
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 120 }}>c. Branch Name</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>
              {challanData?.brancH_NAME || "N/A"}
            </Text>
          </View>

          {/* IFSC Code */}
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 120 }}>d. IFSC Code</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>
              {challanData?.ifsc || "N/A"}
            </Text>
          </View>

          {/* A/C Type */}
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 120 }}>e. A/C Type</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>
              {challanData?.aC_TYPE || "N/A"}
            </Text>
          </View>

          {/* Account Number */}
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 120 }}>f. Account Number</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>
              {challanData?.aC_NUMBER || "N/A"}
            </Text>
          </View>

          {/* Email ID */}
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 120 }}>g. Email ID</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>
              {challanData?.emaiL_ID || "N/A"}
            </Text>
          </View>
        </View>

        <View>
          <Text
            style={{
              fontSize: 10,
              fontWeight: "bold",
              marginBottom: 5,
              marginTop: 5,
            }}
          >
            2. DEPOSITOR DETAILS:
          </Text>

          {/* Center Code */}
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 120 }}>a. School Code</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>
              {challanData?.schooL_CODE || "N/A"}
            </Text>
          </View>

          {/* Center Name */}
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 120 }}>b. School Name</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>
              {challanData?.schooL_NAME || "N/A"}
            </Text>
          </View>

          {/* Purpose of Deposit */}
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 120 }}>
              c. Purpose of Deposit
            </Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>REGISTRATION FEES</Text>
          </View>

          {/* No. of Students */}
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 120 }}>d. No. of Students</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>
              {challanData?.nO_OF_STUDENT || "N/A"}
            </Text>
          </View>
        </View>

        <View>
          <View style={{ flexDirection: "row" }}>
            <Text
              style={{
                fontSize: 10,
                fontWeight: "bold",
                marginBottom: 5,
                marginTop: 5,
                width: 160,
              }}
            >
              3. FEES DETAILS:
            </Text>
            <Text
              style={{
                fontSize: 10,
                fontWeight: "bold",
                marginBottom: 5,
                marginTop: 5,
              }}
            >
              Amount(in RS)
            </Text>
          </View>
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 160 }}>
              a. Registration Fees (in figure) Rs
            </Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>
              {challanData?.exaM_FEES || "0"}
            </Text>
          </View>
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 160 }}>
              b. Late Fees (in figure) Rs
            </Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>
              {challanData?.latE_FEES ?? "0"}
            </Text>
          </View>
          <View
            style={{ flexDirection: "row", marginLeft: 10, marginBottom: 3 }}
          >
            <Text style={{ fontSize: 10, width: 160 }}>
              c. Total Challan Amount
            </Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text style={{ fontSize: 10, flex: 1 }}>
              {challanData?.exaM_FEES + challanData?.latE_FEES || "0"}
            </Text>
          </View>
        </View>

        <View>
          {/* Section Title */}
          <Text
            style={{
              fontSize: 10,
              fontWeight: "bold",
              marginBottom: 5,
              marginTop: 5,
            }}
          >
            4. REMITTANCE DETAILS:
          </Text>

          {/* Amount (in figure) Rs. */}
          <View
            style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}
          >
            <Text style={{ fontSize: 10, width: 150 }}>
              a. Amount (in figure) Rs.
            </Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text
              style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}
            ></Text>
          </View>

          {/* Charges */}
          <View
            style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}
          >
            <Text style={{ fontSize: 10, width: 150 }}>b. A/C Holder Name</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text
              style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}
            ></Text>
          </View>

          {/* Bank Name */}
          <View
            style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}
          >
            <Text style={{ fontSize: 10, width: 150 }}>c. Bank Name</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text
              style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}
            ></Text>
          </View>

          {/* Branch Name */}
          <View
            style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}
          >
            <Text style={{ fontSize: 10, width: 150 }}>d. Branch Name</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text
              style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}
            ></Text>
          </View>

          {/* A/C Type */}
          <View
            style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}
          >
            <Text style={{ fontSize: 10, width: 150 }}>e. A/C Type</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text
              style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}
            ></Text>
          </View>

          {/* A/C No */}
          <View
            style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}
          >
            <Text style={{ fontSize: 10, width: 150 }}>f. A/C No</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text
              style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}
            ></Text>
          </View>

          {/* IFSC Code */}
          <View
            style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}
          >
            <Text style={{ fontSize: 10, width: 150 }}>g. IFSC CODE</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text
              style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}
            ></Text>
          </View>

          {/* UTR No. */}
          <View
            style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}
          >
            <Text style={{ fontSize: 10, width: 150 }}>h. UTR No.</Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text
              style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}
            ></Text>
          </View>

          {/* Date of Remittance */}
          <View
            style={{ flexDirection: "row", marginBottom: 3, marginLeft: 10 }}
          >
            <Text style={{ fontSize: 10, width: 150 }}>
              i. Date of Remittance
            </Text>
            <Text style={{ fontSize: 10, width: 10 }}>:</Text>
            <Text
              style={{ fontSize: 10, borderBottom: "1px solid black", flex: 1 }}
            ></Text>
          </View>
        </View>

        <View style={{ marginTop: 10, marginBottom: 10 }}>
          <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 5 }}>
            5. TOTAL CANDIDATE BREAKUP:
          </Text>

          <View
            style={{
              flexDirection: "row",
              borderWidth: 1,
              borderColor: "black",
            }}
          >
            <View
              style={{ flex: 1, borderRightWidth: 1, borderColor: "black" }}
            >
              <Text
                style={{
                  fontSize: 10,
                  textAlign: "center",
                  fontWeight: "bold",
                  padding: 3,
                }}
              >
                Gender Wise
              </Text>
            </View>
            <View
              style={{ flex: 1, borderRightWidth: 1, borderColor: "black" }}
            >
              <Text
                style={{
                  fontSize: 10,
                  textAlign: "center",
                  fontWeight: "bold",
                  padding: 3,
                }}
              >
                Count
              </Text>
            </View>
            <View
              style={{ flex: 1, borderRightWidth: 1, borderColor: "black" }}
            >
              <Text
                style={{
                  fontSize: 10,
                  textAlign: "center",
                  fontWeight: "bold",
                  padding: 3,
                }}
              >
                Category Wise
              </Text>
            </View>
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 10,
                  textAlign: "center",
                  fontWeight: "bold",
                  padding: 3,
                }}
              >
                Count
              </Text>
            </View>
          </View>

          <View
            style={{
              flexDirection: "row",
              borderWidth: 1,
              borderColor: "black",
              borderTopWidth: 0,
            }}
          >
            <View
              style={{ flex: 1, borderRightWidth: 1, borderColor: "black" }}
            >
              <Text style={{ fontSize: 10, textAlign: "center", padding: 3 }}>
                Male
              </Text>
            </View>
            <View
              style={{ flex: 1, borderRightWidth: 1, borderColor: "black" }}
            >
              <Text style={{ fontSize: 10, textAlign: "center", padding: 3 }}>
                {categoryList.gendeR_MALE || ""}
              </Text>
            </View>
            <View
              style={{ flex: 1, borderRightWidth: 1, borderColor: "black" }}
            >
              <Text style={{ fontSize: 10, textAlign: "center", padding: 3 }}>
                Regular
              </Text>
            </View>
            <View style={{ flex: 1 }}>
              <Text style={{ fontSize: 10, textAlign: "center", padding: 3 }}>
                {categoryList.caT_REGULAR || ""}
              </Text>
            </View>
          </View>

          <View
            style={{
              flexDirection: "row",
              borderWidth: 1,
              borderColor: "black",
              borderTopWidth: 0,
            }}
          >
            <View
              style={{ flex: 1, borderRightWidth: 1, borderColor: "black" }}
            >
              <Text style={{ fontSize: 10, textAlign: "center", padding: 3 }}>
                Female
              </Text>
            </View>
            <View
              style={{ flex: 1, borderRightWidth: 1, borderColor: "black" }}
            >
              <Text style={{ fontSize: 10, textAlign: "center", padding: 3 }}>
                {categoryList.gendeR_FEMALE || ""}
              </Text>
            </View>
            <View
              style={{ flex: 1, borderRightWidth: 1, borderColor: "black" }}
            >
              <Text style={{ fontSize: 10, textAlign: "center", padding: 3 }}>
                Private
              </Text>
            </View>
            <View style={{ flex: 1 }}>
              <Text style={{ fontSize: 10, textAlign: "center", padding: 3 }}>
                {categoryList.caT_PRIVATE || ""}
              </Text>
            </View>
          </View>

          <View
            style={{
              flexDirection: "row",
              borderWidth: 1,
              borderColor: "black",
              borderTopWidth: 0,
            }}
          >
            <View
              style={{ flex: 1, borderRightWidth: 1, borderColor: "black" }}
            >
              <Text style={{ fontSize: 10, textAlign: "center", padding: 3 }}>
                {" "}
              </Text>
            </View>
            <View
              style={{ flex: 1, borderRightWidth: 1, borderColor: "black" }}
            >
              <Text style={{ fontSize: 10, textAlign: "center", padding: 3 }}>
                {" "}
              </Text>
            </View>
            <View
              style={{ flex: 1, borderRightWidth: 1, borderColor: "black" }}
            >
              <Text style={{ fontSize: 10, textAlign: "center", padding: 3 }}>
                Ex-Regular
              </Text>
            </View>
            <View style={{ flex: 1 }}>
              <Text style={{ fontSize: 10, textAlign: "center", padding: 3 }}>
                {categoryList.caT_EX_REGULAR || ""}
              </Text>
            </View>
          </View>
        </View>
        <Text style={styles.note}>
          I hereby declare that the particulars mentioned above are correct and
          true. If the same is found to be false/misleading, I shall abide by
          the decision of JAC.
        </Text>
        <View style={{ marginTop: 10, paddingTop: 5 }}>
          {/* NOTE Section */}
          <View style={{ textAlign: "right", marginTop: 40 }}>
            <Text style={{ fontSize: 8, fontWeight: "bold", marginRight: 30 }}>
              Signature of the Head of the Institution
            </Text>
            <Text style={{ fontSize: 8, marginTop: 2, marginRight: 85 }}>
              (with Seal)
            </Text>
            <View style={styles.separator} />
          </View>
          <Text style={{ fontSize: 10, fontWeight: "bold", marginBottom: 5 }}>
            NOTE:
          </Text>

          <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            1. The institutions are advised to fill up the RTGS/NEFT form as per
            their banker's format, with the details printed in the advice.
          </Text>
          <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            2. After submission of fees through RTGS/NEFT, Upload scan copy.
          </Text>
          <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            3. The institutions are advised to carefully fill point no 4(a) to
            4(i) only after remittance has been made to JAC.
          </Text>
          <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            4. Carefully note the UTR No. for filling up the advice.
          </Text>
          <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            5. Attach a copy of the RTGS/NEFT counter foil/application duly
            signed by the banker along with this advice.
          </Text>
          <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            6. Council copy of the challan will be deposited in the JAC as per
            the direction given in the advertisement.
          </Text>
          {/* <Text style={{ fontSize: 9, marginBottom: 3, marginLeft: 10 }}>
            7. In case of any difficulties, you may contact the above-mentioned
            Contact number.
          </Text> */}
        </View>
      </Page>
    ))}
  </Document>
);

const GeneratePDFXI = () => {
  const [challanData, setChallanData] = useState(null);
  const [categorylist, setCategorylist] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const challanNo = sessionStorage.getItem("challanNo");
    const token = sessionStorage.getItem("tokenclassxi");
    if (!token) {
      alert("Token is missing! Please log in again.");
      setLoading(false);
      return;
    }

    axios
      .post(
        `${config.API_BASE_URL}/GetPdfChallanInfoByChallanNo_CL11`,
        { challanNo: challanNo },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        if (response.data.status !== 200) {
          alert("Error fetching challan data!");

          sessionStorage.removeItem("challanNo");
          setLoading(false);
          return;
        }
        setChallanData(response.data.data.candidateChallanInfo);
        setCategorylist(response.data.data.categoryList);
        // console.log(response.data.data.challan_details[0]);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching challan data:", error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (challanData) {
      // console.log("Challan Data:", challanData);
    }
  }, [challanData]);

  const handlePrint = async () => {
    const blob = await pdf(
      // <ChallanPDF challanData={challanData} />
      <ChallanPDF challanData={challanData} categoryList={categorylist} />
    ).toBlob();

    const url = URL.createObjectURL(blob);
    const newWindow = window.open(url);

    if (newWindow) {
      newWindow.onload = () => {
        newWindow.focus();
        newWindow.print();
      };
    }
  };
  return (
    <div style={{ textAlign: "center" }}>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div style={{ textAlign: "right" }}>
            <button
              style={{ margin: "5px 5px 0px 0px" }}
              onClick={handlePrint}
              className="btn btn-danger btn-sm"
            >
              <i className="fa fa-print"></i> Print PDF
            </button>
          </div>
          <PDFViewer width="100%" height="600px">
            <ChallanPDF challanData={challanData} categoryList={categorylist} />
            {/* <ChallanPDF challanData={challanData} /> */}
          </PDFViewer>
          <br />
        </>
      )}
    </div>
  );
};

export default GeneratePDFXI;
